import React from 'react';
export type CSTabType = 'all' | 'assigned' | 'escalated';
export type CSTabListType = {
  text: string;
  value: CSTabType;
  className: string;
  onClick?: () => void;
};
const CSTab = ({
  active,
  setActive,
  list
}: {
  active: CSTabType;
  setActive: (item: CSTabType) => void;
  list: CSTabListType[];
}) => {
  return (
    <div className='flex my-3'>
      {list.map(({ text, value, className, onClick }) => (
        <div
          key={value}
          className={`cursor-pointer text-sm border-none py-2 px-3 w-fit min-w-[120px] text-center font-medium ${
            active === value ? 'text-white bg-gray-6' : 'bg-gray-11 text-gray-4'
          } ${className}`}
          onClick={() => {
            setActive(value);
            onClick?.();
          }}>
          {text}
        </div>
      ))}
    </div>
  );
};

export default CSTab;
